import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-o-nas',
  templateUrl: './o-nas.component.html',
  styleUrls: ['./o-nas.component.css']
})
export class ONasComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle("Stolarstvo-Krisanda: informacie o nas");
    this.metaTagService.updateTag({name: 'description', content: "Stolarstvo na mieru v Presove. Vyrobime pre vas rozny nabytok ako kuchyne, Dvere, Schody, spalne, postele, skrine, komody a ine"});
  }

}
